import React, { useState } from 'react';
import {
  Button, Modal, Alert,
} from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useMessageError } from '../../../../hooks/common';
import { useTemporaryMeterReadingsExportCSV } from '../../../../hooks/api/settings';
import downloadCSV from '../../../../utils/csv';

function MeterReadingsCsvExportButton() {
  const meterReadingsExportCSV = useTemporaryMeterReadingsExportCSV();
  const [isOpen, setIsOpen] = useState(false);
  const [csvData, setCsvData] = useState<string | null>(null);

  useMessageError([meterReadingsExportCSV]);

  const showModal = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setCsvData(null);
  };

  const handleDownload = () => {
    if (csvData) {
      downloadCSV(csvData, '', 'temporary-meter-readings');

      return;
    }

    meterReadingsExportCSV.fetch()
      .then((res) => {
        if (res && typeof res === 'string') {
          setCsvData(res);
          downloadCSV(res, '', 'temporary-meter-readings');
        }
      });
  };

  return (
    <>
      <Button type="primary" onClick={showModal} icon={<DownloadOutlined />}>
        Export CSV
      </Button>
      <Modal
        title={(
          <span>
            <DownloadOutlined />
            {' '}
            Export temporary meter-reading records
          </span>
        )}
        open={isOpen}
        onCancel={handleClose}
        centered
        footer={[
          <Button key="back" onClick={handleClose}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={meterReadingsExportCSV.loading}
            onClick={handleDownload}
          >
            Download
          </Button>,
        ]}
      >
        <Alert
          message="By clicking 'Download', you will export a CSV file of temporary meter-reading records."
          type="info"
          showIcon
        />
      </Modal>
    </>
  );
}

export default MeterReadingsCsvExportButton;
